import {QuestionCircleFilled as AntdQuestionCircleFilled} from '@ant-design/icons';

export default function QuestionCircleFilled(props) {
  return <AntdQuestionCircleFilled {...props} />;
}
